module.exports = __webpack_public_path__ + "img/orderempty.d9cb22ca.png";